module.exports = __webpack_public_path__ + "static/media/raceday-3.8e544695.png";